import { initialize } from 'redux-form';
import { CommanderThunkAction } from '@mews-commander/types';
import { openDialog } from '../../../../../modules/dialog/reducer';
import { print, showPdf } from '../../../Actions/print';
import { getPrintParams } from '../Action/PrintAction';
import { PRINT_BILL_PDF_INPUT_VALUE } from '../Action/PrintFinancialDocumentAction';
import { formName as printReasonForm } from '../PrintReasonDialogForm';
import { formName as repeatedPrintForm } from '../RepeatedPrintDialogForm';
import { FormValues as PrintBillModalDialogFormFormValues } from './types';

export const submitPrintBillModal =
    (formValues: PrintBillModalDialogFormFormValues): CommanderThunkAction =>
    (dispatch) => {
        const params = getPrintParams({
            printerId: formValues.printer,
            action: formValues.action,
            languageCode: formValues.language,
            templateType: formValues.template,
        });

        const {
            requirePrintReasonOnReprint,
            isReprint,
            reloadOnPrint,
            url: pdfUrl,
            requirePrintReasonOnTemplateChange,
            firstUsedTemplateType,
        } = formValues.action;

        const firstUsedTemplate = firstUsedTemplateType || formValues.firstUsedTemplateType;

        const isRepeatedPrint =
            !!requirePrintReasonOnTemplateChange && !!firstUsedTemplate && firstUsedTemplate !== formValues.template;

        const isFirstPrintWithPrintReason =
            requirePrintReasonOnReprint && !isReprint && !formValues.firstUsedTemplateType;

        const isFirstPrintWithTemplateChangeReason = requirePrintReasonOnTemplateChange && !firstUsedTemplate;

        const shouldPrintModalReload =
            reloadOnPrint && !isFirstPrintWithPrintReason && !isFirstPrintWithTemplateChangeReason;

        if (formValues.showPrintReasonDialog || isReprint) {
            dispatch(openDialog(printReasonForm));
            dispatch(
                initialize(printReasonForm, {
                    printParams: params,
                    type: 'pdf',
                    pdfUrl,
                    reloadOnPrint,
                })
            );
        } else if (isRepeatedPrint) {
            dispatch(openDialog(repeatedPrintForm));
            dispatch(
                initialize(repeatedPrintForm, {
                    printParams: params,
                    type: 'pdf',
                    pdfUrl,
                    reloadOnPrint,
                    firstUsedTemplateType: firstUsedTemplate,
                })
            );
        } else {
            if (formValues.printer === PRINT_BILL_PDF_INPUT_VALUE) {
                dispatch(showPdf(params, pdfUrl, shouldPrintModalReload));
            } else {
                dispatch(print(params, pdfUrl, shouldPrintModalReload));
            }

            if (requirePrintReasonOnReprint) formValues.setShowPrintReasonDialog(true);
            if (requirePrintReasonOnTemplateChange && !firstUsedTemplate) {
                formValues.setFirstUsedTemplateType(formValues.template);
            }
        }
    };
